import styled from 'styled-components';
import {TextField} from '@mui/material';
import {media} from '../../../theme';

export const LoginCard = styled.div`
    width: 100%;
    max-width: 450px;
    padding: 24px;
    background: ${({theme}) => theme.palette.background.paper};
    border: 1px solid ${({theme}) => theme.palette.dividers.subtle};
    border-radius: 40px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 8px;

    ${media.sm} {
        padding: 32px;
        gap: 10px;
    }

    ${media.md} {
        padding: 40px;
        gap: 12px;
    }
`;

export const FormWrapper = styled.form`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 16px;

    ${media.md} {
        gap: 22px;
    }
`;

export const StyledTextField = styled(TextField)`
    && {
        width: 100%;

        .MuiOutlinedInput-root {
            border-radius: 16px;
            background-color: ${({theme}) => theme.palette.background.input};

            & fieldset {
                border-color: ${({theme}) => theme.palette.dividers.subtle};
            }

            &:hover fieldset {
                border-color: ${({theme}) => theme.palette.dividers.focus};
            }

            &.Mui-focused fieldset {
                border-color: ${({theme}) => theme.palette.dividers.focus};
            }

            &.Mui-error fieldset {
                border-color: ${({theme}) => theme.palette.error.main};
            }

            &.Mui-error:hover fieldset {
                border-color: ${({theme}) => theme.palette.error.main};
            }

            &.Mui-error.Mui-focused fieldset {
                border-color: ${({theme}) => theme.palette.error.main};
            }
        }

        .MuiInputLabel-root {
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
            color: ${({theme}) => theme.palette.text.primary};

            &.Mui-focused {
                color: ${({theme}) => theme.palette.text.primary};
            }

            &.Mui-error {
                color: ${({theme}) => theme.palette.error.main};
            }

            &.Mui-error.Mui-focused {
                color: ${({theme}) => theme.palette.error.main};
            }
        }

        input {
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
            color: ${({theme}) => theme.palette.text.primary};
        }

        input:-webkit-autofill {
            box-shadow: 0 0 0 1000px #ffffff inset;
            -webkit-text-fill-color: ${({theme}) => theme.palette.text.primary};
        }
    }
`;

export const ForgotPasswordWrapper = styled.div<{ disabled?: boolean }>`
    width: 100%;
    text-align: right;
    margin-top: -10px;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: ${({theme}) => theme.palette.text.primary};
    cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
    opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
    text-decoration: underline;
    
    &:hover {
        text-decoration: none;
    }
`;

export const RegisterLink = styled.div<{ disabled?: boolean }>`
    margin-top: 10px;
    text-align: center;
    width: 100%;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: ${({theme}) => theme.palette.text.primary};
    cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
    opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
    text-decoration: underline;

    &:hover {
        text-decoration: ${({ disabled }) => (disabled ? 'underline' : 'none')};
    }
`;

export const ErrorText = styled.div`
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: ${({theme}) => theme.palette.error.main};
    margin-top: 4px;
`;
